<div class="bg-[#491176] min-h-screen">
    <portals-navbar></portals-navbar>

    <!-- Overarching Title -->
    <div class="text-center pt-8">
        <h1 class="text-3xl font-bold text-[#FBD354]" style="font-family: 'Roboto', sans-serif;">
            Contact Us Now!
        </h1>
    </div>

    <!-- Content Section -->
    <div class="flex items-start justify-center min-h-screen pb-[76px] space-x-24">
        <!-- Form Section -->
        <div class="flex items-center justify-center heightB pb-[76px]">
            <div class="flex flex-col items-center">
                <!-- Smaller Section Title -->
                <h2 class="text-xl font-semibold text-[#FBD354]" style="font-family: 'Roboto', sans-serif;">
                    Fill out the Form
                </h2>
                <!-- Form -->
                <div *ngIf="!emailSent && !emailSending" class="inputWButton">
                    <!-- Global Error Message -->
                    <div *ngIf="errorMessage" class="text-red-500 mt-2 text-left">
                        {{ errorMessage }}
                    </div>

                    <form [formGroup]="requestForm" (ngSubmit)="sendEmail()">
                        <div class="grid grid-cols-2 gap-4">
                            <!-- Name Field -->
                            <div class="flex flex-col">
                                <label for="name" class="mb-1 text-white text-left">Name</label>
                                <input
                                        id="name"
                                        formControlName="name"
                                        required
                                        class="bg-white text-black p-2 rounded border"
                                        [ngClass]="{
                    'border-red-500': requestForm.get('name')?.invalid && requestForm.get('name')?.touched,
                    'border-gray-300': requestForm.get('name')?.valid || !requestForm.get('name')?.touched
                  }"
                                        placeholder="Enter Name"
                                />
                                <div *ngIf="requestForm.get('name')?.invalid && requestForm.get('name')?.touched" class="text-red-500 text-sm text-left">
                                    Name is required.
                                </div>
                            </div>

                            <!-- Email Field -->
                            <div class="flex flex-col">
                                <label for="email" class="mb-1 text-white text-left">Email</label>
                                <input
                                        id="email"
                                        type="email"
                                        formControlName="email"
                                        required
                                        class="bg-white text-black p-2 rounded border"
                                        [ngClass]="{
                    'border-red-500': requestForm.get('email')?.invalid && requestForm.get('email')?.touched,
                    'border-gray-300': requestForm.get('email')?.valid || !requestForm.get('email')?.touched
                  }"
                                        placeholder="Enter email"
                                />
                                <div *ngIf="requestForm.get('email')?.invalid && requestForm.get('email')?.touched" class="text-red-500 text-sm text-left">
                                    A valid email is required.
                                </div>
                            </div>

                            <!-- Cell Number Field (Optional) -->
                            <div class="flex flex-col">
                                <label for="number" class="mb-1 text-white text-left">Cell Number</label>
                                <input
                                        id="number"
                                        type="tel"
                                        formControlName="number"
                                        class="bg-white text-black p-2 rounded border"
                                        [ngClass]="{
                    'border-red-500': requestForm.get('number')?.invalid && requestForm.get('number')?.touched,
                    'border-gray-300': requestForm.get('number')?.valid || !requestForm.get('number')?.touched
                  }"
                                        placeholder="Enter cell number"
                                />
                                <div *ngIf="requestForm.get('number')?.invalid && requestForm.get('number')?.touched" class="text-red-500 text-sm text-left">
                                    This is not a valid number.
                                </div>
                            </div>

                            <!-- Organization Field (Optional) -->
                            <div class="flex flex-col">
                                <label for="organization" class="mb-1 text-white text-left">Organization</label>
                                <input
                                        id="organization"
                                        formControlName="organization"
                                        class="bg-white text-black p-2 rounded border"
                                        [ngClass]="{
                    'border-red-500': requestForm.get('organization')?.invalid && requestForm.get('organization')?.touched,
                    'border-gray-300': requestForm.get('organization')?.valid || !requestForm.get('organization')?.touched
                  }"
                                        placeholder="Enter your organization"
                                />
                                <!-- No validation message needed -->
                            </div>

                            <!-- Message Field -->
                            <div class="flex flex-col col-span-2">
                                <label for="message" class="mb-1 text-white text-left">Message</label>
                                <textarea
                                        id="message"
                                        formControlName="message"
                                        required
                                        class="bg-white text-black p-2 rounded h-20 resize-none border"
                                        [ngClass]="{
                    'border-red-500': requestForm.get('message')?.invalid && requestForm.get('message')?.touched,
                    'border-gray-300': requestForm.get('message')?.valid || !requestForm.get('message')?.touched
                  }"
                                        placeholder="Tell us why you're reaching out"
                                ></textarea>
                                <div *ngIf="requestForm.get('message')?.invalid && requestForm.get('message')?.touched" class="text-red-500 text-sm text-left">
                                    A message is required.
                                </div>
                            </div>
                        </div>

                        <!-- Checkbox for Text Message Consent -->
                        <div *ngIf="requestForm.get('number')?.value" class="flex flex-col col-span-2 mt-4">
                            <div class="flex items-start space-x-2">
                                <input
                                        id="textConsent"
                                        type="checkbox"
                                        formControlName="textConsent"
                                        class="mt-1"
                                        [ngClass]="{
        'border-red-500': requestForm.get('textConsent')?.invalid && requestForm.get('textConsent')?.touched
      }"
                                />
                                <label for="textConsent" class="text-white text-sm leading-tight">
                                    By checking this box, I agree to receive text messages from Jotto at this number. Msg frequency varies. Msg & data
                                    rates may apply. Reply STOP to cancel anytime. View our
                                    <a href="/policies/terms" rel="noopener noreferrer" target="_blank" class="underline">Terms</a> &amp;
                                    <a href="/policies/privacy" rel="noopener noreferrer" target="_blank" class="underline">Privacy Policy</a>.
                                </label>
                            </div>
                            <div
                                    *ngIf="requestForm.get('textConsent')?.invalid && requestForm.get('textConsent')?.touched"
                                    class="text-red-500 text-sm text-left"
                            >
                                You must agree to receive text messages.
                            </div>
                        </div>

                        <!-- Submit Button -->
                        <div class="flex justify-center mt-4">
                            <button
                                    type="submit"
                                    class="py-2 px-6 font-bold"
                                    style="background-color: #fbd364; color: #491176; border-radius: 100px;"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>

                <!-- Success and Sending Messages -->
                <div *ngIf="emailSent" class="font-bold text-[#FBD354]" style="font-family: 'Roboto', sans-serif;">
                    Thank you! We will be in touch soon.
                </div>
                <div *ngIf="emailSending" class="text-white">Sending email...</div>
            </div>
        </div>

        <!-- Contact Section -->
        <div class="text-center flex flex-col items-center">
            <!-- Smaller Section Title -->
            <h2 class="text-xl font-semibold text-[#FBD354]" style="font-family: 'Roboto', sans-serif;">
                Send us a Jott
            </h2>
            <img src="/assets/images/qr-code-yellow.png" loading="lazy" class="image" alt="QR Code" />
            <button
                    (click)="goToSendMessage()"
                    class="submit-button mt-5 py-[10px] rounded-xl font-bold"
                    style="background-color: #fbd364; color: #491176; border-radius: 100px;"
            >
                Jott Request
            </button>
        </div>
    </div>
</div>
